var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPoweredByVega(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1220px",
    height: "417px",
    viewBox: "0 0 1220 417",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Artboard") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polyline", {
    id: "path-1",
    points: "93.7307593 75.1524815 93.7307593 38.7167593 58.6918519 96.8735926 0.512592593 0.304351852 58.6918519 193.446037 94.3266481 75.1524815 93.7307593 75.1524815"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-117.979032%",
    y1: "49.9998341%",
    x2: "231.104054%",
    y2: "49.9998341%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D2031",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFE",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("polyline", {
    id: "path-4",
    points: "1.02518519 119.760852 72.2915741 1.4672963 36.6599815 1.4672963 1.02518519 119.760852"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-236.942234%",
    y1: "49.9994583%",
    x2: "222.58575%",
    y2: "49.9994583%",
    id: "linearGradient-6"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E4287",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#49B6DC",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "path-7",
    points: "58.1792593 0.304351852 116.358519 193.446037 0.192222222 0.624722222 0.192222222 0.304351852"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-8.68916113%",
    y1: "55.8073004%",
    x2: "45.3134063%",
    y2: "55.8073004%",
    id: "linearGradient-9"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E4287",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#49B6DC",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "path-10",
    points: "0.192222222 0.304351852 116.358519 0.304351852 116.358519 193.446037 0.192222222 193.446037"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-12",
    points: "3.09477778 1.65311111 285.731926 1.65311111 285.731926 185.622593 3.09477778 185.622593"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Powered-by",
    fontFamily: "RubikRoman-Regular, Rubik",
    fontSize: 96,
    fontWeight: "normal",
    "line-spacing": 112.032,
    fill: "#273754"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 35,
    y: 99.968
  }, "Powered by")), /*#__PURE__*/React.createElement("g", {
    id: "Logos/Vega-Logo/Color",
    transform: "translate(578.000000, 40.500000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(57.666667, 96.111111)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-1",
    fill: "url(#linearGradient-3)",
    mask: "url(#mask-2)",
    points: "93.7307593 75.1524815 93.7307593 38.7167593 58.6918519 96.8735926 0.512592593 0.304351852 58.6918519 193.446037 94.3266481 75.1524815 93.7307593 75.1524815"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(115.333333, 169.796296)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-5",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-5"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-4",
    fill: "url(#linearGradient-6)",
    mask: "url(#mask-5)",
    points: "1.02518519 119.760852 72.2915741 1.4672963 36.6599815 1.4672963 1.02518519 119.760852"
  })), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-7",
    fill: "#1C2030",
    points: "116.358519 289.557148 187.624907 171.263593 151.993315 171.263593 116.358519 289.557148"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-10",
    transform: "translate(0.000000, 96.111111)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-8",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-9"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-8",
    fill: "url(#linearGradient-9)",
    mask: "url(#mask-8)",
    points: "0.192222222 249.696667 606.6245 249.696667 606.6245 -96.1111111 0.192222222 -96.1111111"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-13",
    transform: "translate(0.000000, 96.111111)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-11",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-10"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-12"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-11",
    fill: "#1C2030",
    mask: "url(#mask-11)",
    points: "0 0.304351852 116.358519 193.446037 58.1792593 0.304351852 0 0.304351852"
  })), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-14",
    fill: "#482C50",
    points: "176.043519 111.677907 160.057037 111.677907 212.014704 162.770574 212.014704 111.677907 176.043519 111.677907"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-15",
    fill: "#783882",
    points: "160.057037 111.677907 160.057037 162.770574 212.014704 162.770574 160.057037 111.677907"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-16",
    fill: "#1977A3",
    points: "235.533093 54.5526667 260.989722 79.5767963 260.989722 54.5526667 235.533093 54.5526667"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-17",
    fill: "#1DA1CF",
    points: "235.533093 79.5767963 260.989722 79.5767963 235.533093 54.5526667 235.533093 79.5767963"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-18",
    fill: "#E5722A",
    points: "253.813426 -7.10542736e-15 228.363204 -7.10542736e-15 253.813426 25.0241296 253.813426 -7.10542736e-15"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-19",
    fill: "#ED9B3A",
    points: "228.363204 -7.10542736e-15 228.363204 25.0241296 253.813426 25.0241296 228.363204 -7.10542736e-15"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-20",
    fill: "#26603A",
    points: "212.818833 12.510463 179.445852 12.510463 179.445852 12.5232778 212.818833 45.3452222 212.818833 12.510463"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-21",
    fill: "#3DA547",
    points: "179.445852 12.5232778 179.445852 45.3452222 212.818833 45.3452222 179.445852 12.5232778"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-22",
    fill: "#902C2F",
    points: "209.989963 94.4387778 209.989963 66.399963 181.467389 66.399963 209.989963 94.4387778"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-23",
    fill: "#CF323F",
    points: "181.467389 94.4387778 209.989963 94.4387778 181.467389 66.399963 181.467389 94.4387778"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-24",
    fill: "#1B5880",
    points: "155.360407 39.79 112.065556 39.79 155.360407 82.3672222 155.360407 39.79"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-25",
    fill: "#1DA1CF",
    points: "112.065556 39.79 112.059148 39.7867963 112.059148 82.3672222 155.360407 82.3672222 112.065556 39.79"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-29",
    transform: "translate(173.000000, 160.185185)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-13",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-12"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.399,48.5104815 C95.9669444,42.6028519 93.019537,37.8645741 88.5663889,34.2892407 C84.110037,30.7171111 78.6957778,28.9294444 72.3300185,28.9294444 C65.6470926,28.9294444 60.1943889,30.6402222 55.9783148,34.0553704 C51.759037,37.4769259 49.0935556,42.2952963 47.9786667,48.5104815 L97.399,48.5104815 Z M46.7836852,72.9867778 C46.7836852,91.171 55.5394074,100.263111 73.0476481,100.263111 C82.4377037,100.263111 89.5210926,96.5307963 94.2946111,89.0725741 L136.077315,89.0725741 C127.638759,116.422593 106.551981,130.099204 72.8073704,130.099204 C62.4626111,130.099204 52.992463,128.583852 44.3969259,125.556352 C35.8045926,122.525648 28.4424815,118.213463 22.3137963,112.616593 C16.1883148,107.022926 11.4532407,100.34 8.10857407,92.5678148 C4.76711111,84.7988333 3.09477778,76.0975741 3.09477778,66.4608333 C3.09477778,56.5133333 4.68701852,47.5397593 7.8682963,39.5337037 C11.0527778,31.5308519 15.5892222,24.7325926 21.4776296,19.1389259 C27.366037,13.5420556 34.4910741,9.22987037 42.8463333,6.19916667 C51.2015926,3.16846296 60.6332963,1.65311111 71.135037,1.65311111 C81.483,1.65311111 90.792963,3.16846296 99.0713333,6.19916667 C107.3465,9.22987037 114.349796,13.6221481 120.078019,19.3695926 C125.809444,25.1202407 130.185704,32.1523704 133.21,40.4659815 C136.234296,48.7827963 137.746444,58.1472222 137.746444,68.5592593 L137.746444,72.9867778 L46.7836852,72.9867778 L46.7836852,72.9867778 Z",
    id: "Fill-26",
    fill: "#1C2030",
    mask: "url(#mask-13)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.80387,65.2946852 C188.80387,69.1807778 189.5215,72.7913519 190.950352,76.1328148 C192.385611,79.4774815 194.336667,82.3896481 196.803519,84.8757222 C199.27037,87.3617963 202.21137,89.3064444 205.63613,90.7032593 C209.057685,92.1032778 212.757963,92.8016852 216.736963,92.8016852 C220.555778,92.8016852 224.175963,92.1032778 227.600722,90.7032593 C231.022278,89.3064444 233.966481,87.3617963 236.433333,84.8757222 C238.900185,82.3896481 240.889685,79.4774815 242.401833,76.1328148 C243.913981,72.7913519 244.670056,69.2576667 244.670056,65.5285556 C244.670056,61.642463 243.913981,58.0671296 242.401833,54.8057593 C240.889685,51.5411852 238.858537,48.667463 236.314796,46.1781852 C233.767852,43.6921111 230.782,41.7506667 227.360444,40.3506481 C223.938889,38.9538333 220.395593,38.2522222 216.736963,38.2522222 C212.914944,38.2522222 209.336407,38.9922778 205.991741,40.4659815 C202.650278,41.9428889 199.706074,43.887537 197.15913,46.2967222 C194.612185,48.7059074 192.584241,51.5411852 191.072093,54.8057593 C189.559944,58.0671296 188.80387,61.5655741 188.80387,65.2946852 Z M285.731926,6.08383333 L285.731926,117.511852 C285.731926,124.194778 285.334667,130.176093 284.540148,135.462204 C283.742426,140.745111 282.630741,145.409704 281.198685,149.449574 C279.289278,154.578704 276.303426,159.355426 272.244333,163.786148 C268.185241,168.213667 263.289981,172.061315 257.561759,175.325889 C251.830333,178.587259 245.346037,181.150222 238.105667,183.017981 C230.862093,184.882537 223.02263,185.814815 214.587278,185.814815 C205.037037,185.814815 196.284519,184.648667 188.326519,182.319574 C180.368519,179.987278 173.403667,176.761148 167.435167,172.644389 C161.466667,168.524426 156.571407,163.709259 152.752593,158.192481 C148.933778,152.6725 146.386833,146.649537 145.111759,140.123593 L193.817667,140.123593 C196.841963,148.052759 203.685074,152.012537 214.350204,152.012537 C223.423093,152.012537 230.384741,149.526463 235.238352,144.554315 C240.091963,139.578963 242.52037,132.66537 242.52037,123.80713 L242.52037,112.382722 C239.335889,115.336537 236.273148,117.784167 233.328944,119.725611 C230.384741,121.670259 227.398889,123.2625 224.374593,124.505537 C221.3535,125.748574 218.169019,126.642407 214.827556,127.187037 C211.486093,127.731667 207.821056,128.003981 203.845259,128.003981 C195.089537,128.003981 187.054648,126.527074 179.730981,123.573259 C172.410519,120.619444 166.083204,116.502685 160.752241,111.216574 C155.421278,105.933667 151.282093,99.5999444 148.337889,92.2186111 C145.393685,84.8372778 143.919981,76.639 143.919981,67.6269815 C143.919981,58.4579815 145.512222,49.9489444 148.6935,42.0998704 C151.877981,34.2507963 156.215796,27.4140926 161.706944,21.5833519 C167.198093,15.7590185 173.720833,11.1713148 181.281574,7.82985185 C188.842315,4.48838889 197.079037,2.81925926 205.991741,2.81925926 C220.475685,2.81925926 232.652963,8.10216667 242.52037,18.6711852 L242.52037,6.08383333 L285.731926,6.08383333 L285.731926,6.08383333 Z",
    id: "Fill-28",
    fill: "#1C2030",
    mask: "url(#mask-13)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M508.738537,225.713741 C508.738537,229.599833 509.452963,233.213611 510.888222,236.555074 C512.320278,239.893333 514.26813,242.808704 516.734981,245.294778 C519.201833,247.780852 522.146037,249.722296 525.570796,251.122315 C528.992352,252.51913 532.69263,253.220741 536.67163,253.220741 C540.490444,253.220741 544.11063,252.51913 547.535389,251.122315 C550.956944,249.722296 553.901148,247.780852 556.368,245.294778 C558.834852,242.808704 560.824352,239.931778 562.3365,236.670407 C563.848648,233.405833 564.604722,229.907389 564.604722,226.178278 C564.604722,222.449167 563.848648,218.915481 562.3365,215.574019 C560.824352,212.232556 558.834852,209.317185 556.368,206.831111 C553.901148,204.345037 550.956944,202.400389 547.535389,201.003574 C544.11063,199.603556 540.490444,198.905148 536.67163,198.905148 C532.69263,198.905148 528.992352,199.603556 525.570796,201.003574 C522.146037,202.400389 519.201833,204.345037 516.734981,206.831111 C514.26813,209.317185 512.320278,212.152463 510.888222,215.340148 C509.452963,218.52463 508.738537,221.98463 508.738537,225.713741 Z M563.172667,166.269019 L606.621296,166.269019 L606.621296,285.85687 L563.172667,285.85687 L563.172667,272.567907 C553.939593,283.915426 541.445148,289.585981 525.689333,289.585981 C516.77663,289.585981 508.578352,287.993741 501.097704,284.806056 C493.617056,281.621574 487.091111,277.152407 481.523074,271.401759 C475.951833,265.654315 471.614019,258.8945 468.50963,251.122315 C465.405241,243.353333 463.854648,234.882741 463.854648,225.713741 C463.854648,217.166259 465.366796,209.04487 468.391093,201.352778 C471.415389,193.660685 475.631463,186.939315 481.045722,181.188667 C486.456778,175.438019 492.90263,170.891963 500.383278,167.5505 C507.863926,164.209037 516.139093,162.536704 525.211981,162.536704 C540.490444,162.536704 553.145074,167.742722 563.172667,178.157963 L563.172667,166.269019 L563.172667,166.269019 Z",
    id: "Fill-30",
    fill: "#1C2030"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoweredByVega);
export default __webpack_public_path__ + "static/media/powered-by-vega.7030a515ff0396f388a0bd3ed0fd0577.svg";
export { ForwardRef as ReactComponent };